import { createSelector } from '@reduxjs/toolkit';
import { extractUndefinedValue } from 'shared/utils/extractUndefinedValue';

import { selectAdfoxOffer } from './selectAdfoxOffer';

export const selectAdfoxOfferResponseData = createSelector(selectAdfoxOffer, state =>
  extractUndefinedValue(state?.response?.data),
);
